import gql from 'graphql-tag';

const GET_EVENTTRIGGER_AUTOMATIONRULES = gql`
  query($automationRuleType: AutomationRuleType!) {
    getAutomationRules(automationRuleType: $automationRuleType) {
      id
      name
      description
      ruleOrder
      ruleGroup
      event
      active
    }
  }
`;

const GET_AUTOMATION_RULE = gql`
  query($id: ID!, $automationRuleType: AutomationRuleType!) {
    getAutomationRule(id: $id, automationRuleType: $automationRuleType) {
      id
      name
      description
      ruleOrder
      ruleGroup
      ruleCondition
      event
      active
      action {
        type
        data {
          name
          value
        }
      }
      timerDuration {
        unit
        quantity
      }
    }
  }
`;

const GET_TIMETRIGGER_AUTOMATIONRULES = gql`
  query($automationRuleType: AutomationRuleType!) {
    getAutomationRules(automationRuleType: $automationRuleType) {
      id
      name
      description
      ruleOrder
      ruleGroup
      ruleCondition
      timerDuration {
        unit
        quantity
      }
      event
      active
    }
  }
`;

const ADD_AUTOMATION_RULE = gql`
  mutation(
    $name: String
    $description: String
    $ruleOrder: Int
    $ruleGroup: String
    $event: String
    $ruleCondition: RuleConditionInput
    $action: [RuleActionInput!]
    $timerDuration: [FixedDurationInput]
    $automationRuleType: AutomationRuleType
  ) {
    addAutomationRule(
      automationRuleType: $automationRuleType
      input: {
        name: $name
        description: $description
        ruleOrder: $ruleOrder
        ruleGroup: $ruleGroup
        event: $event
        ruleCondition: $ruleCondition
        action: $action
        timerDuration: $timerDuration
      }
    ) {
      id
      name
      description
      ruleCondition
      ruleOrder
      ruleGroup
      event
      timerDuration {
        unit
        quantity
      }
    }
  }
`;

const UPDATE_AUTOMATION_RULE = gql`
  mutation(
    $id: ID!
    $name: String
    $description: String
    $ruleOrder: Int
    $ruleGroup: String
    $event: String
    $ruleCondition: RuleConditionInput
    $action: [RuleActionInput!]
    $active: Boolean
    $actionModified: Boolean
    $timerDuration: [FixedDurationInput]
    $automationRuleType: AutomationRuleType
  ) {
    updateAutomationRule(
      id: $id
      automationRuleType: $automationRuleType
      input: {
        name: $name
        description: $description
        ruleOrder: $ruleOrder
        ruleGroup: $ruleGroup
        event: $event
        ruleCondition: $ruleCondition
        action: $action
        active: $active
        actionModified: $actionModified
        timerDuration: $timerDuration
      }
    ) {
      id
      name
      description
      ruleCondition
      ruleOrder
      ruleGroup
      event
      action {
        type
        data {
          name
          value
        }
      }
      timerDuration {
        unit
        quantity
      }
    }
  }
`;

const ORGANIZE_AUTOMATION_RULES = gql`
  mutation($rules: [AutomationRuleInput!]) {
    organizeAutomationRule(input: $rules)
  }
`;

const ADD_EVENT_TRIGGER_AUTOTION_RULE = gql`
  mutation(
    $name: String
    $description: String
    $ruleOrder: Int
    $ruleGroup: String
    $event: String
    $ruleCondition: RuleConditionInput
    $action: [RuleActionInput!]
    $active: Boolean
  ) {
    addAutomationRule(
      input: {
        name: $name
        description: $description
        ruleOrder: $ruleOrder
        ruleGroup: $ruleGroup
        event: $event
        ruleCondition: $ruleCondition
        action: $action
        active: $active
      }
    ) {
      name
      description
    }
  }
`;

const ADD_EVENT_TRIGGER_AUTOMATION_RULE = gql`
  mutation(
    $name: String!
    $description: String
    $ruleOrder: Int!
    $ruleGroup: String!
    $event: String!
    $ruleCondition: RuleConditionInput
    $action: [RuleActionInput!]
    $active: Boolean!
    $automationRuleType: AutomationRuleType
  ) {
    addAutomationRule(
      automationRuleType: $automationRuleType
      input: {
        name: $name
        description: $description
        ruleOrder: $ruleOrder
        ruleGroup: $ruleGroup
        event: $event
        ruleCondition: $ruleCondition
        action: $action
        active: $active
      }
    ) {
      id
      name
      description
      ruleOrder
      ruleGroup
      event
      ruleCondition
      action {
        type
        data {
          name
          value
        }
      }
      active
    }
  }
`;

const GET_AUTOMATION_RULE_CONFIGURATION = gql`
  query {
    getAutomationRuleConfiguration {
      name
      value
    }
  }
`;

const UPDATE_AUTOMATION_RULE_CONFIGURATION = gql`
  mutation($properties: [AppPropertiesInput]) {
    updateAutomationRuleConfiguration(properties: $properties)
  }
`;

const DELETE_AUTOMATION_RULE = gql`
  mutation($id: ID!, $automationRuleType: AutomationRuleType) {
    deleteAutomationRule(id: $id, automationRuleType: $automationRuleType)
  }
`;

export {
  ADD_EVENT_TRIGGER_AUTOMATION_RULE,
  ORGANIZE_AUTOMATION_RULES,
  GET_AUTOMATION_RULE,
  ADD_AUTOMATION_RULE,
  DELETE_AUTOMATION_RULE,
  GET_EVENTTRIGGER_AUTOMATIONRULES,
  UPDATE_AUTOMATION_RULE,
  GET_TIMETRIGGER_AUTOMATIONRULES,
  GET_AUTOMATION_RULE_CONFIGURATION,
  UPDATE_AUTOMATION_RULE_CONFIGURATION
};
